<template>
<div>
    <smallbutton toplabel="Change Password" @click="Add()"/>
    <!--  MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form ref="changepassform" v-on:keyup.enter="SaveNewPassword" @submit.prevent>
              <div class="vertFlex">
                  <label class="titlelabel">Change Password</label>
                <div class="changePass">
                    <!-- <formentrystacked inputid="old" inputtype="password" label="Old password" v-model="oldpassword"  isrequired="true" /> -->
                    <formentrystacked  inputid="new" inputtype="password" label="New password" v-model="newpassword" minlength="8" isrequired="true" placeholder="minimum 8 characters"/>
                    <formentrystacked inputid="confirm" inputtype="password" label="Confirm New password" v-model="confirmpassword" minlength="8" isrequired="true" placeholder="minimum 8 characters"/>
                </div>
                
                <div >

                  <smallbutton toplabel="Save" v-on:click='SaveNewPassword()' class='loginButton'/>
                  <smallbutton toplabel="Cancel" v-on:click='cancelchangepass()' class='loginButton'/>
                </div>
              
              </div>
              <div>
                <label class="responsemessage">{{message}}</label>
              </div>
            </form>
            
        </template>
      </actionmodal>
    </div>
</template>

<script>
import datamethods from '../../datamethods.js'
import format from '../../format.js'
import smallbutton from '../controls/button.vue'
import actionmodal from '../controls/actionmodal.vue'
import formentrystacked from '../controls/entry-stacked.vue'
export default {
    name:'changepass',
    components:{
        smallbutton,
        actionmodal,
        formentrystacked
    },
    props:{
         userEmail:{
            type:String,
            
        },
        
    },
    mixins:[format,datamethods],
    data(){
        return{
            
            responseMessage:'',
            pleaseWait:false,

            newpassword:'',
            confirmpassword:'',
            overrideOldPassword:'dbbuilder'
        }
    },
    computed:{

    },
    methods:{
        beforeAPI(){
            this.pleaseWait=true
            this.responseMessage=''
        },
        Add(){
             this.changepass()
            this.$refs.mymodal.openModal()
        },
       async SaveNewPassword(){
          if(this.$refs.changepassform.checkValidity()==false){return}
          
          var response = await this.ChangePassword(this.userEmail,this.overrideOldPassword, this.newpassword, this.confirmpassword)
        
          if(response.Successful){
            this.password=""
            this.$refs.mymodal.closeModal()
          }else{
            this.message = response.Message
          }
          this.pleaseWait=false;
        },
        changepass(){
          this.isChangePass=true;
          this.oldpassword='',
          this.newpassword=''
          this.confirmpassword=''
          this.message=''
        },
        cancelchangepass(){
          this.$refs.mymodal.closeModal()
        },
        
    }
}
</script>

<style>
.entryCheckLabel{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
}
.entryCheckLabelbold{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
    font-weight:bold;
}
</style>





























